<!-- 卡密管理 -->
<template>
    <div class="cardpwdManage-container">
        
        <el-card class="mb16">
            <div class="cardpwdManage-query">
                <div class="cardpwdManage-query-input">
                    <div class="query-input-item">
                        <span class="input-item-label"> 产品编码:</span>
                        <el-input class="query-input" size="small" placeholder="请输入" v-model="query.product_code" clearable></el-input>
                    </div>
                    <div class="query-input-item">
                        <span class="input-item-label"> 产品名称:</span>
                        <el-input size="small" placeholder="请输入" v-model="query.product_name" clearable></el-input>
                    </div>
                   
                </div>
                
                <div class="cardpwdManage-query-input query-input-flex-end">
                    <div class="cardpwdManage-query-btn">
                        <el-button class="query-btn" type="primary" size="small" @click="getData" :disabled="query.loading" icon="el-icon-search">查询</el-button>
                        <el-button class="query-btn cancel" plain size="small" @click="reset" :disabled="query.loading" icon="el-icon-refresh">重置</el-button>
                    </div>
                </div>
                
            </div>
        </el-card>
        <el-card>
            <div class="cardpwdManage-btn-div">            
                <el-button class="add-btn" type="primary" size="small" @click="addCardBag" icon="el-icon-plus">新增产品</el-button>
                <el-button class="add-btn" type="warning" size="small" @click="batchClose" icon="el-icon-plus">一键关闭</el-button>
                <el-button class="add-btn" type="success" size="small" @click="batchOpen" icon="el-icon-plus">一键开启</el-button>
            </div>
            <div class="cardpwdManage-table-div">
                <el-table class="table-class"  :data="table.tableData" style="width: 100%;" header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                    <el-table-column prop="product_code" label="产品编码" width="120px" ></el-table-column>
                    <el-table-column prop="product_name" label="产品名称" ></el-table-column>
                    
                    <el-table-column label="面值" width="240px" align="center">
                        <template slot-scope="scope">
                            <div class="face-value-list">
                               <el-tag size="mini" type="primary" v-for="item in scope.row.denominations" :key="item.id">{{ item.value }}元</el-tag>                                
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="240px" align="center">
                        <template slot-scope="scope">
                            <div class="face-value-list">
                               <el-tag size="small" :type="scope.row.status == 1 ? 'success' : 'danger'">{{scope.row.status == 1 ? '开启' : '关闭'}}</el-tag>                                
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time" sortable = 'custom' label="创建时间" width="160px"></el-table-column>
                    <el-table-column label="操作" width="160px">
                        <template slot-scope="scope">
                            <el-dropdown @command="handleCommand($event,scope.row)" trigger="click">
                                <span class="el-dropdown-link">
                                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="editCardBag"><i class="el-icon-edit-outline"></i>编辑</el-dropdown-item>
                                    <el-dropdown-item command="openXianYuLink"><i class="el-icon-link"></i>咸鱼链接</el-dropdown-item>
                                    <el-dropdown-item command="deleteData"><i class="el-icon-delete "></i><span class="cdanger">删除</span></el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="flexX pageBox flexEnd">
                    <el-pagination :disabled="query.loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="query.pageSizesArr"
                        :page-size="query.pageSize" layout="total, sizes, prev, pager, next" :total="query.total"></el-pagination>
                </div>
            </div>
        </el-card>
        <div class="dialog-div">
            <ProductEdit v-if="dialog.visible" type="add" :dialogVisible = "dialog.visible" :formData="dialog.form" :loading="dialog.loading" title="新建产品" @close = "close" @sure="addProduct" @deleteFaceValue="deleteFaceValue"></ProductEdit>
            <ProductEdit v-if="dialog.editVisible" type="edit" :dialogVisible = "dialog.editVisible" :formData="dialog.editForm" :loading="dialog.loading" title="编辑产品" @close = "editClose" @sure="editProduct" @deleteFaceValue="deleteDenomination"></ProductEdit>
            <XianYuManage v-if="dialog.XianYuManage.visible" :dialogVisible = "dialog.XianYuManage.visible" title="闲鱼链接管理" :formData="dialog.XianYuManage.form" @close = "xianyuClose"></XianYuManage>
           
        </div>
        
    </div>

   
</template>
<script>
	import { Message } from 'element-ui'
    import ProductEdit from '@/components/cardPwdManage/productEdit.vue'
    import XianYuManage from '@/components/cardPwdManage/xianYuManage.vue'
    export default {
        name: 'cardpwdManage',
        components:{
            ProductEdit,
            XianYuManage
        },

        data() {
            var checkPrice = function (rule, val, callback) {
                    if (val) {                   
                        var reg = /^\d+(\.{0,1}\d{1,4}){0,1}$/;
                        if (!reg.test(val)) {
                            return callback(new Error("格式错误,至多四位小数"));
                        } 
                    }
                    return callback();
                };
               
            //卡包名称验证
            const validateBagName = function(rule, val, callback) {
                if(val){
                    if(val.length < 2 || val.length > 10){
                        return callback(new Error("名称长度不得少于 2 个字符，最多 10 个字符"));
                    }
                    if (/^\d+$/.test(val)) {
                        callback(new Error('名称只能包含中英文和数字，请重新输入'));
                    } else if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(val)) {
                        callback(new Error('名称只能包含中英文和数字，请重新输入'));
                    } else {
                        callback();
                    }
                }
            };

			return {
                traderId:'',//客户id 
				query:{
                    loading:false,
                    product_code:'',
                    product_name:'',
                    page:1,
                    pageSizesArr:[10,50,200,500],
                    total:0,
                    pageSize: 10,

                },
                table:{
                    tableData:[],
                    height:'200px',
                  
                },
                dialog:{
                    //新增 编辑弹窗
                    loading:false,
                    top:"15vh",
                    visible:false,
                    title:'',
                    type:'add',
                    form:{
                        product_code:'',
                        product_name:'',
                        status:1,
                        denominations:[
                            // {
                            //     value: "",
                            //     goods_url: "",
                            //     status: 1
                            // }
                        ],
                    }, 
                    editVisible:false,
                    editForm:{
                        product_code:'',
                        product_name:'',
                        status:1,
                    },
                    XianYuManage:{
                        visible:false,
                        form:{},
                    }
                        
                }, 
                rules:{
                    productName:[{ required: true, message: '请输入产品名称', trigger: 'blur' },
                    ],
                  
                },
               
            };
        },
        created() {
           this.productList()
        },
        computed: {
        },
        methods: {
            ////计算窗口位置
            getDialogTop(className){
                this.$nextTick(() => {			
                    let documentHeight = document.documentElement.clientHeight
                    let dialogdiv =  document.getElementsByClassName(className)[0].offsetHeight
                    this.dialog.top =( documentHeight - dialogdiv) / 2 +'px'
                    console.log(documentHeight,'===',dialogdiv,'===',this.dialog.top)
                })
            },
            //计算表格高度
            getTableHeight(){
                this.$nextTick(() => {
                    let topNav = document.getElementsByClassName('topNav')[0].offsetHeight;
                    let queryBox = document.getElementsByClassName('cardpwdManage-query')[0].offsetHeight;
                    let queryBtn = document.getElementsByClassName('cardpwdManage-btn-div')[0].offsetHeight;
                    let pageBox = document.getElementsByClassName('pageBox')[0].offsetHeight;
                    let documentHeight = document.documentElement.clientHeight
                    this.table.height = documentHeight - topNav - 20 - queryBox - 26 - queryBtn - 31 - 31 - 30 - pageBox - 70 +'px'
                })  
            },
            //查询按钮
            getData(){
                this.query.page = 1;
                this.query.total = 0
                this.productList()
            },
            //卡密管理 查询列表
            productList(){
                this.getTableHeight()
                let data = {
                    "product_code": this.query.product_code.trim(),// 产品编码  筛选项可以为空
                    "product_name": this.query.product_name.trim(), // 产品名称 筛选项可以为空                    
                    "size": this.query.pageSize,
                    "page": this.query.page,
                }
                this.query.loading = true;
                this.$api.productList(data).then(res=>{
                    this.query.loading = false;
                    if(res.status == 1){
                        this.table.tableData = res.data.data
                        this.query.total = res.data.total;
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.query.loading = false;
                })
            },
             // 分页查询数据
             handleSizeChange(val){
                this.query.pageSize = val;
                this.query.page = 1
                this.query.total = 0
                this.productList()
            },
            handleCurrentChange(val){
                this.query.page = val
                this.productList()
            },
            // 重置查询条件
            reset(){
                this.query.product_name="";
                this.query.product_code="";
                this.query.page=1;
                this.query.total = 0;
                this.productList()
            },
            //新增卡包
            addCardBag(){
                this.dialog.visible = true
                this.dialog.title='新建产品'
                this.dialog.type = 'add'
                //计算窗口位置
                // this.getDialogTop('new-dialog-class')
            },
              //关闭新增卡包弹窗
              close(){
                this.dialog.visible = false               
                this.dialog.form={
                    product_code:'',
                    product_name:'',
                    status:1,
                    denominations:[],
                }               
            },


            //操作
            handleCommand(command, row){                
                this[command](row);            
            },
            //编辑卡包
            editCardBag(item){
                this.dialog.editVisible = true
                this.dialog.editForm = JSON.parse(JSON.stringify(item))
            },      
            //新增产品接口
            addProduct(form){
                let data = {
                    "product_code": form.product_code,// 客户id
                    "product_name": form.product_name, // 卡包名称
                    "status": form.status,// 产品名称
                    "denoms":form.denominations,
                    card_prefix:form.card_prefix,
                }
                console.log(data,'======')
                this.dialog.loading = true;
                this.$api.addProduct(data).then(res=>{
                this.dialog.loading = false;
                    if(res.status == 1){
                        this.dialog.visible = false;
                        this.getData()
                        Message({
                            message: res.msg,
                            type: 'success',
                            duration: 3 * 1000
                        })
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        })
                    }
                }).catch(e=>{                    
                    this.dialog.loading = false;
                })
                
            },
            editClose(){
                this.dialog.editVisible = false
                this.dialog.editForm={
                        product_code:'',
                        product_name:'',
                        status:1,
                    }
            },   
            //编辑卡包
            editProduct(form){
                let data = {
                    "id":form.id,
                    "product_code": form.product_code,// 客户id
                    "product_name": form.product_name, // 卡包名称
                    "status": form.status,// 产品名称
                    "denoms":form.denominations,
                    card_prefix:form.card_prefix,
                }
                // console.log(data,'data')
                this.dialog.loading = true
                this.$api.editProduct(data).then(res=>{                    
                    this.dialog.loading = false
                    if(res.status == 1){
                        this.dialog.editVisible = false;
                        this.productList()
                        Message({
                            message:res.msg,
                            type:"success",
                            duration: 3 * 1000
                        })
                    }else{
                        Message({
                            message:res.msg,
                            type:"error",
                            duration: 3 * 1000
                        })
                    }
                }).catch(e=>{
                    this.dialog.loading = false
                })
            },
            //删除
            deleteData(item){
                this.$confirm('请解绑所有关联此产品的商户后操作', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        id:item.id
                    }
                    this.$api.deleteProduct(data).then(res=>{
                        if(res.status == 1){
                            Message({
                                message:res.msg,
                                type:"success",
                                duration: 3 * 1000
                            })
                            this.getData()
                        }else{
                            
                            Message({
                                message:res.msg,
                                type:"error",
                                duration: 3 * 1000
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
                    
               
            },
            //新增弹窗删除面值 
            deleteFaceValue(index){
                this.dialog.form.denominations.splice(index,1)
                // this.formData.faceValue.splice(this.formData.faceValue.indexOf(this.formData.faceValue[this.formData.faceValue.length-1]),1)
            },
            //编辑弹窗删除面值
            deleteDenomination(index){
                // this.$confirm('此操作会从商品中删除此面值，是否继续？', '提示', {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning'
                // }).then(() => { 
                    if(this.dialog.editForm.denominations[index].id){
                        let data = {
                            id:this.dialog.editForm.denominations[index].id
                        }
                        this.$api.deleteDenomination(data).then(res=>{ 
                            if(res.status == 1){ 
                                this.productList()
                                this.dialog.editForm.denominations.splice(index,1)
                                this.$message.success(res.msg)
                            }else{
                                this.$message.error(res.msg)
                            }
                        })
                    }else{
                        this.dialog.editForm.denominations.splice(index,1)
                    }
                // }).catch(() => {})
                
               
            },
            //
            suerFaceValue(){
                
            },
            //一键关闭
            batchClose(){
                this.$confirm('确定要一键关闭所有产品吗？关闭后产品将不可提卡与核销', '一键关闭确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {                    
                    this.batchSetProductStatus(0)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            //一键开启
            batchOpen(){
                this.$confirm('确定要一键开启所有产品吗？', '一键开启确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {                    
                    this.batchSetProductStatus(1)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            //一键修改产品状态接口
            batchSetProductStatus(status){
                let data = {
                    status:status,
                }
                this.$api.batchSetProductStatus(data).then(res=>{ 
                    if(res.status == 1){
                        this.getData()
                        this.$message.success(res.msg)
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
             
            //关闭闲鱼链接管理弹窗
            xianyuClose(){
                this.dialog.XianYuManage.visible = false;
                this.dialog.XianYuManage.form = {};
            },
            openXianYuLink(item){
                this.dialog.XianYuManage.visible = true;
                this.dialog.XianYuManage.form = {...item};
            }
           
        },
    }
</script>
<style lang="scss">
    @import "@/style/tablestyle.scss";
    .cardpwdManage-container{
        .dialog-div{
            .el-form-item__label{
                // width: 90px !important;
            }
        }
    }
	// @import '@/style/variables.scss';
</style>
<style lang="scss" scoped>
//内层弹窗input框样式
    .dialog-div-input{
        // width:
    }
    .cardpwdManage-container{
        padding-top: 10px;
        padding-right: 10px;
        .cardpwdManage-query{
            padding-left:34px;
           
            .cardpwdManage-query-input{
                display:flex;
                flex-wrap: wrap;
                .query-input-item{
                    margin-right:25px;
                    display:flex;
                    font-size:14px;
                    align-items:center;
                    margin-bottom: 16px;
                    .input-item-label{
                        white-space: nowrap;
                        margin-right: 10px;
                        color: #606266;
                    }
                    .query-input{
                        width: 200px;
                        margin-left: 20px;
                    }
                    
                }
                &.query-input-flex-end{
                    justify-content: flex-end;
                }
            }
            .cardpwdManage-query-btn{
                margin-left: 7px;
                .query-btn{
                    width: 80px;
                    height: 30px;
                }
                .cancel{
                    margin-left: 14px;
                }
            }
        }          
        .cardpwdManage-btn-div{   
            display: flex;
            // justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            padding: 16px 20px;
            border-bottom: 1px solid #ebeef5;
            background-color: #fafcff;
            gap: 15px;
            // padding-left:34px;
            .add-btn{
                // width: 80px;
                height: 30px;
                // margin-top:31px;
            }
        }
        .cardpwdManage-table-div{
            margin-top: 31px;
            margin-left:10px;
            .face-value-list{
                display: flex;
                flex-wrap: wrap;
                gap: 4px;
                justify-content: center
            }
            .table-operation{
                margin-right: 10px;
            }
           .pageBox{
            padding: 16px 20px;
            border-top: 1px solid #ebeef5;
            background-color: #fafcff;
            // position:absolute;  
            // bottom: 50PX;
            // right: 30px;

           }
           .delete-btn{
            &:hover{
                color:#fab6b6,
            }
            &:focus{
                color:#fab6b6,
            }
           }
           .table-class{
            .el-dropdown-link {
                cursor: pointer;
                color: #409EFF;
            }
            .el-icon-arrow-down {
                font-size: 12px;
            }
           }
        }
       
        
    }
    .dialog-div {
        // .new-dialog-class{
            .dialog-box{
                max-height:70vh !important;
                overflow-y:auto;
            }
            
            .dialog-block-box{
                .dialog-block-box-title{
                    font-weight:600;
                    font-size:16px;
                    margin-bottom: 20px;
                }
                .form-error-div{
                    padding-left:100px;
                }
                .dialog-radio-group{
                    width:280px;
                    .dialog-radio{
                        margin-top: 7px;
                        margin-bottom:13px;
                    }
                }
            }
            
        // }
    }
    .card-list-dialog-class {
            .dialog-box{
                .dialog-info-div{
                    padding-right: 30px;
                    display: flex;
                    justify-content: space-between;
                }
                .dialog-query-box{ 
                    padding-right: 30px;
                    margin-top:30px;
                    // display: flex;
                    // justify-content: space-between;
                    .dialog-query-btn-box{
                        .query-btn{
                            width: 80px;
                            height: 30px;
                        }
                    }
                }
                .dialog-table-box{
                    margin-top:35px;
                    .dialog-card-list-page{
                        margin-top: 30px;
                        justify-content: flex-end;
                    }
                }
            }
        }
</style>